<div class="page-layout simple full-width">
    <!-- HEADER -->
    <div class="header p-24 pb-0" fxLayout="row" fxLayoutAlign="space-between center">

        <div fxLayout="column" fxLayoutAlign="center start" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            <div class="h2 mt-5"> Slider </div>
        </div>

        <button mat-button [routerLink]="'/slider'" class="mt-0 mt-md-0">
            <mat-icon>arrow_back</mat-icon>
            <span>Volver</span>
        </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

            <mat-progress-bar *ngIf="isLoading" mode="buffer"></mat-progress-bar>

            <!-- REACTIVE FORM EXAMPLE -->

            <div *ngIf="!isLoading" class="mat-card mat-elevation-z4 p-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form">

                <ng-container *ngFor="let field of configFields">

                    <mat-form-field *ngIf="field.type == 'string'" appearance="outline" class="pl-4">
                        <mat-label>{{ field.title }}</mat-label>
                        <input matInput [name]="field.key" [(ngModel)]="item[field.key]" />
                    </mat-form-field>

                    <mat-form-field  *ngIf="field.type == 'select'" appearance="outline" fxFlex="80">
                        <mat-label>{{ field.title }}</mat-label>
                        <mat-select name="parent_id" [(ngModel)]="item[field.key]">
                            <mat-option *ngFor="let opt of field.options" [value]="opt.value">
                                {{ opt.title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div *ngIf="field.type == 'file' && field.fileType == 'path'" class="pl-4" style="margin-bottom: 20px;">
                        <mat-label>{{ field.title }}</mat-label>
                        <div fxLayout="row">
                            <mat-spinner *ngIf="isUploadingFile[field.key]" [diameter]="50"></mat-spinner>
                            <img *ngIf="item[field.key] && item[field.key].length > 0" [src]="item[field.key]" class="m-b-5" style="width: 100px; height: 100px; object-fit: cover; margin-right: 10px;" /><br/>
                            <div *ngIf="!isUploadingFile[field.key]">
                                <input #inputFile type="file" (change)="onUploadFiles($event.target.files, field, item)" style="display: none;" />
                                <button mat-raised-button type="button" class="btn btn-outline-secondary" (click)="inputFile.click()">Subir imagen <i class="fa fa-upload"></i></button><br/>
                                <button *ngIf="item[field.key] && item[field.key].length > 0" mat-raised-button color="warn"  type="button" class="ml-1 btn btn-outline-danger" (click)="item[field.key] = ''" style="margin-top: 5px;">Eliminar <i class="fa fa-trash"></i></button>
                            </div>
                        </div>
                    </div>

                </ng-container>

                <!--<mat-form-field appearance="outline" fxFlex="80">
                    <mat-label>Seleccionar padre:</mat-label>
                    <mat-select name="parent_id" [(ngModel)]="category.parent_id">
                        <mat-option [value]="0">Ninguno</mat-option>
                        <mat-option *ngFor="let comp of categories" [value]="comp.id">
                            {{ comp.title }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>-->

                

                <mat-progress-bar *ngIf="isSending" mode="buffer"></mat-progress-bar>

                <div *ngIf="!isSending" fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <button [routerLink]="'/' + pathUrlList" mat-raised-button color="warn" class="mt-24 mt-md-0 mr-4">
                        <span>Cancelar</span>
                    </button>

                    <button type="button" (click)="onClickSave()" mat-raised-button color="primary" class="mt-24 mt-md-0">
                        <span>Guardar y volver</span>
                    </button>
                </div>



            </div>

            <!-- / REACTIVE FORM EXAMPLE -->

        </div>

    </div>
    <!-- / CONTENT -->
</div>